export type PromptCardProps = {
  text: string;
  className?: string;
  compact?: boolean;
  "aria-hidden"?: boolean | "true" | "false";
  /** When set, card is a button (e.g. jump photo stack to a matching example). */
  onActivate?: () => void;
};

/**
 * Web mirror of the app’s RN PromptCard: white surface, rounded corners, medium black text.
 */
export function PromptCard({
  text,
  className = "",
  compact = false,
  "aria-hidden": ariaHidden,
  onActivate,
}: PromptCardProps) {
  const baseWrap = [
    "max-w-[min(100%,18rem)] rounded-xl border-2 border-transparent bg-white text-left text-black shadow-lg shadow-black/25",
    compact
      ? "my-0 px-4 py-2.5 text-left sm:px-5 sm:py-3"
      : "my-1 px-4 py-3.5 sm:px-5 sm:py-4",
    onActivate &&
      "cursor-pointer transition hover:ring-2 hover:ring-violet-400/45 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-400",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const body = (
    <p
      className={[
        "font-medium text-black",
        compact ? "text-sm leading-snug" : "text-base leading-[22px]",
      ].join(" ")}
    >
      {text}
    </p>
  );

  if (onActivate) {
    return (
      <button
        type="button"
        aria-hidden={ariaHidden}
        aria-label={`Show example photo for: ${text}`}
        className={[
          baseWrap,
          "block w-full appearance-none font-inherit",
        ].join(" ")}
        onClick={onActivate}
      >
        {body}
      </button>
    );
  }

  return (
    <div
      aria-hidden={ariaHidden}
      className={baseWrap}
    >
      {body}
    </div>
  );
}
